import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import { onClickBtnModifier } from 'actions/businessLibrary/item';
import styles from './ItemModifier.css';

class ItemModifier extends React.Component {
  render() {
    const { modifiers } = this.props;
    return (
      <div>
        {modifiers.map(
          modifier =>
            modifier.selected && (
              <div className="top-8" key={modifier.id}>
                <li className={styles['list-item']}>
                  <label
                    className={styles['list-text']}
                    htmlFor={`modifier-${modifier.id}`}
                  >
                    {modifier.name}
                  </label>
                </li>
              </div>
            )
        )}
        <div className="row">
          <div className="col-sm-12 col-md-12">
            <button
              type="button"
              onClick={this._onClickBtnModifiers}
              className="btn btn-primary btn-block no-border-radius-top"
            >
              Manage Modifier
            </button>
            <div className={styles['modifier-text-desc']}>
              <span>
                Click Manage Modifier to edit, add, or remove modifier for your
                item
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onClickBtnModifiers = () => {
    const { dispatch, item } = this.props;

    dispatch(onClickBtnModifier(item));
  };
}

function mapStateToProps(state) {
  return {
    item: getFormValues('itemHub')(state),
    search: getFormValues('search')(state),
  };
}

export default connect(mapStateToProps)(ItemModifier);
